export default __webpack_public_path__ + "static/10-common-travel-mistakes-how-to-avoid-356c0d9a227ae064057361af07801d1d.jpg";